import React from 'react';
import moment from 'moment';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import styles from './attachments.module.css';
import { IconButton, Tooltip } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/AddBox';
import { VisibilityOff, CloudDownloadOutlined, DeleteOutlineOutlined } from '@material-ui/icons';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import pdfDefault from '../../assets/pdfDefault.svg'; 
import attachmentTypes from '../../configs/attachmentTypes';
import Attachment from '../../models/Attachment';
import attachmentsRequestHandler from '../../api/attachmentsRemote';
import { isImg, isDoc, getNameById } from '../../utils/attachment';

const materialStyles = (theme: Theme) =>
  createStyles({
    materialIcon: {
      marginLeft: '15px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    materialIconAdd: {
      fontSize: '35px'
    },
    materialIconRed: {
      color: 'red'
    },
    materialIconAcc: {
      fontSize: '40px',
      marginRight: '20px',
      display: 'inline-block'
    }
  });

interface AttachmentsProps {
  classes: any;
  closeAttachments: (event:any) => void;
  code: string;
  number: string;
  attachmentType: string;
  changeAttachmentType: (event: any) => void;
  attachFile: (event: any) => void;
  attachmentsList: Array<Attachment>;
  handleDelete: Function;
  changeAccessibility: Function;
  process: 'import' | 'export';
  onlyRead? : boolean;
  pasteClipboardImage: (event: any) => void;
  selectAttachmentType: (event: any, type: any) => void;
};

const attachments = (props: AttachmentsProps) => {
  const attachmentTypesArr: Array<{id: string; label: string}> = attachmentTypes.attachmentTypes[props.process];
  const attachmentTypeOptions: Array<JSX.Element> = attachmentTypesArr.map((item:{id: string; label: string}) => (
    <option key={ item.id } value={ item.id }>{ item.label }</option>
  ));

  const openLink = (link: string):void => {
    window.open(link);
  }

  const attachmentsList: Array<JSX.Element> = props.attachmentsList.map((item:Attachment) => {
    const itemLink: string = attachmentsRequestHandler.constructAttachmentUrl(item.attachment_key);
    let addedBy: string;
    
    if (item.autodoc_recognition_added == null) {
      addedBy = item.user_uploaded_name;
    }
    else {
      if (item.user_uploaded_name == ' ') {
        addedBy = 'Automatic Documents Recognition';
      }
      else {
        addedBy = 'Document identified by ' + item.user_uploaded_name;
      }
    }

    return ( 
      <div key={ item.id } className={styles.attachmentItem}>
        <AccountCircleIcon color="primary" className={ props.classes.materialIconAcc }/> 
        <div className={styles.attachmentHeader}>
          <div>
            Added by: { addedBy }           
          </div>
          { item.fwd_company_name &&
          <div>
            Forwarder: { item.fwd_company_name }
          </div> }
          { item.gha_company_name &&
          <div>
            GHA: { item.gha_company_name }
          </div> }
          <div>
            <b>{ moment(item.timestamp).format('DD MMM YY HH:mm z') }</b>
          </div>
        </div>
        { isImg(item.uploaded_filename) && 
          <img src={itemLink} alt={item.uploaded_filename} className={styles.thumbnail} onClick={() => {openLink(itemLink)}}/>
        }
        { isDoc(item.uploaded_filename) && 
          <img src={pdfDefault} alt={item.uploaded_filename} className={styles.thumbnail} onClick={() => {openLink(itemLink)}}/>
        }
        <div className={styles.attachmentItemActions}>
          <div className={styles.privacyActionWrapper}>
            { item.updatable && !props.onlyRead &&
              <Tooltip title="Visiblity">
                <VisibilityOff 
                  className={item.public? props.classes.materialIcon : `${props.classes.materialIcon} ${props.classes.materialIconRed}`} 
                  onClick={() => {props.changeAccessibility(item)}}
                />
              </Tooltip>
            }
          </div>
          <div className={styles.itemTypeName}>
          <FormControl className={ styles.formControl }>
                <Select native
                  onChange={(e) => {props.selectAttachmentType(item, e)}}
                  value={ item.attachment_type }
                  disabled={props.onlyRead}
                >
                { attachmentTypeOptions }
                </Select>
              </FormControl></div>
          <div>
            <Tooltip title="Download">
              <CloudDownloadOutlined className={ props.classes.materialIcon } onClick={() => {openLink(itemLink)}} />
            </Tooltip>
            { item.updatable && !props.onlyRead &&
            <Tooltip title="Delete">
              <DeleteOutlineOutlined className={ props.classes.materialIcon } onClick={() => {props.handleDelete(item.attachment_key)}} />
            </Tooltip>
            }
          </div>
        </div>
      </div>
    );
  });

  return (
    <div>
      <div className={ styles.overlay } onClick={ props.closeAttachments }></div>
      <div className={ styles.attachmentsWrapper } onPaste={ props.pasteClipboardImage }>
        <div className={ styles.attachmentsHeader }>
          <div className={ styles.titleBlk } >
            <div className={ styles.title }>Attachments</div>
            <div className={ styles.attachmentsHeaderText }>{props.code}-{props.number}</div>
          </div>
          <div className={ styles.attachmentsButton } onClick={ props.closeAttachments } >
            <IconButton aria-label="Close">
              <Close color="primary"/>
            </IconButton> 
          </div>
        </div>
        <div className={ styles.attachmentsBody} >
          { !props.onlyRead && 
            <div className={ styles.attachmentsForm }>
              <div className={ styles.attachmentsLabel }>Select Documents you wish to attach</div>
              <FormControl className={ styles.formControl }>
                <Select native
                  onChange={ props.changeAttachmentType }
                  value={ props.attachmentType }
                >
                { attachmentTypeOptions }
                </Select>
              </FormControl>
              <label htmlFor="fileUpload">
                <AddIcon color="primary" className={`${props.classes.materialIcon} ${props.classes.materialIconAdd}`}/>
              </label>
              <input id="fileUpload" type="file" name="attachment" className={styles.fileUpload} onChange={props.attachFile}/>
            </div>
          }
          <div>{attachmentsList}</div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(materialStyles)(attachments);